<template>
 <div>
  <el-drawer
    class="cls-drawer"
    title="基本信息"
    :withHeader="true"
    :visible.sync="drawer"
    :show-close="false"
    size="35%"
  >
    <el-form class="cls-form" :model="aiInfo" label-position="top">
      <el-form-item  label="名称">
        <el-input v-model="aiInfo.aiName"  placeholder="请输入AI名称" :minlength="1" :maxlength="40" show-word-limit/>
      </el-form-item>
      <el-form-item label="描述">
        <el-input v-model="aiInfo.aiDesc" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea" :maxlength="1000" show-word-limit/>
      </el-form-item>
      <el-form-item label="欢迎语">
        <el-input v-model="aiInfo.aiWelcome" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea" :maxlength="1000" show-word-limit/>
      </el-form-item>
      <el-form-item label="头像">
        <el-upload
          class="avatar-uploader"
          action="/aigenai/allAi/uploadFile"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img class="avatar-img" v-if="aiInfo.headImg" :src="aiInfo.headImg">
          <div v-else>
            <i class="el-icon-plus avatar-uploader-icon"></i>
            <div class="avatar-bottom">
              <span>拖拽或点击上传头像</span><br>
              <span style="font-size: 5px; opacity: 0.5;">支持jpg/png格式，最大5M</span>
            </div>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="是否公开">
        <el-radio-group v-model="aiInfo.open">
          <el-radio :label="1">公开</el-radio>
          <el-radio :label="0">私有</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="cls-form__bottom">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>
  </el-drawer>
 </div>
</template>
<script>
  export default {
    name: 'AI-New-Basic',
    data() {
      return {
        drawer: false,
        aiInfo: {
          aiName: '',
          aiDesc: '',
          aiWelcome: '',
          headImg: '',
          open: 1,
        },
      };
    },
    watch: {
      drawer:{
        handler(newVal, oldVal){
          if (!newVal) {
            this.aiInfo = {}
          }
          if (newVal && !this.$route.query.id) {
            this.aiInfo = {open: 1}
          }
        }
      }
    },
    methods: {
      createAi(drawer, id){
        this.drawer = drawer
        if (id) {
          this.$http.get(`/aigenai/allAi/detail/${id}`).then(
            res=>{
              if (res.code !== 0) {return}
              this.aiInfo = res.data
            }
          ).catch(err=>{console.log('err', err)})
        }
      },
      // 上传图片成功之后处理
      handleAvatarSuccess(res, file) {
        if (res.code === 1) {
          this.$message({message: res.msg, type: 'error'})
          return 
        }
        this.aiInfo.headImg = process.env.VUE_APP_IMAGE_URL + (res.data ? res.data.substr(res.data.indexOf('/aigenai')) : '')
        // console.log('this.aiInfo.headImg', this.aiInfo.headImg)
      },
      // 上传图片之前处理
      beforeAvatarUpload(file){
        const isFormat = file.type === 'image/jpeg'  || file.type === 'image/jpg' || file.type === 'image/png';
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isFormat) {
          this.$message.error('头像图片只能是 jpg/png 格式!');
        }
        if (!isLt5M) {
          this.$message.error('头像图片大小不能超过 5MB!');
        }
        return isFormat && isLt5M;
      },
      // 提交表单内容
      onSubmit(){
        if (!this.aiInfo.aiName) {
          this.$message({message: '未填写AI名称', type: 'error'})
          return
        }
        if (!this.aiInfo.headImg) {
          this.$message({message: '未上传AI头像', type: 'error'})
          return
        }
        if (this.aiInfo.open == null) {
          this.$message({message: '未选择是否公开', type: 'error'})
          return
        }
        console.log('this.aiInfo', this.aiInfo)
        this.$http.post('/aigenai/allAi/add', {...this.aiInfo}).then(
          res=>{
            if (res.code !== 0) {return}
            this.drawer = false
            this.aiInfo = {}
            this.$store.dispatch('getAllList')
          }
        ).catch(err=>{console.log('err', err)})
      },
      cancel() {
        this.drawer = false
        this.aiInfo = {}
      }
    },
    mounted() {
      this.$bus.$on('createAi', this.createAi)
    },
    beforeDestroy() {
      // 销毁创建AI刷新列表
      this.$bus.$off('createAi');
    },
  }
</script>
<style lang="less" scoped>
@import url(../style/my-element.less);
.cls-drawer{
  top: 120px;
  /* bottom: 100px; */
}
.cls-form {
  width: 360px; 
  margin-left: 30px;
}
.avatar-uploader{
  position: relative;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 200px;
  height: 200px;
  background-color: #fff;
}
.avatar-uploader:hover {
  border-color: #409EFF;
  color: #409EFF;
}
.avatar-uploader-icon {
  position: absolute;
  font-size: 28px;
  color: #8c939d;
  top: 80px;
  left: 80px;
}
.avatar-bottom{
  position: absolute;
  width: 100%;
  bottom: 0px;
  span{
    margin: 0 auto;
  }
}
.avatar-img {
  width: 200px;
  height: 200px;
  display: block;
}
</style>
